webpackJsonp([54024051353029],{

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ContentStyle = exports.innerWrapperStyle = exports.titleStyle = exports.imgStyle = undefined;
	
	var _css, _css2, _nthChildOdd, _nthChildEven, _ref, _css3;
	
	var _emotion = __webpack_require__(6);
	
	var _globalStyles = __webpack_require__(4);
	
	var imgStyle = /*#__PURE__*/exports.imgStyle = (0, _emotion.css)((_css = {
		background: '#F6F6F6',
		width: '350px',
		height: '300px',
		margin: '15px 0 0 30px',
		position: 'relative',
		borderRadius: '6px',
		'& img': {
			width: '100%',
			height: '100%',
			display: 'block',
			position: 'absolute',
			borderRadius: '6px',
			top: '-30px',
			left: '-30px'
		}
	}, _css['@media (max-width: ' + _globalStyles.tabletLandscapeMaxWidthBreakpoint + 'px)'] = {
		width: '297px',
		height: '255px'
	}, _css['@media (max-width: ' + _globalStyles.tabletPortraitMaxWidthBreakpoint + 'px)'] = {
		width: '201px',
		height: '174px',
		margin: '15px 0 41px 30px'
	}, _css['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		display: 'none'
	}, _css));
	
	var titleStyle = exports.titleStyle = (0, _emotion.cx)(_globalStyles.headingLarge, /*#__PURE__*/(0, _emotion.css)({
		marginBottom: '31px'
	}));
	
	var innerWrapperStyle = /*#__PURE__*/exports.innerWrapperStyle = (0, _emotion.css)((_css3 = {
		maxWidth: _globalStyles.desktopMaxWidthBreakpoint,
		width: '100%',
		height: '100%',
		margin: '70px auto',
		padding: '0 20px',
		'& p': (0, _emotion.cx)(_globalStyles.textBlock, /*#__PURE__*/(0, _emotion.css)((_css2 = {
			maxWidth: '800px'
		}, _css2['@media (max-width: ' + _globalStyles.tabletLandscapeMaxWidthBreakpoint + 'px)'] = {
			maxWidth: '534px'
		}, _css2))),
		'&:after': {
			display: 'block',
			content: "' '",
			clear: 'both'
		},
		'&:nth-child(odd)': (_nthChildOdd = {}, _nthChildOdd['& > * '] = {
			'&:first-child': {
				float: 'left'
			},
			'&:last-child': {
				float: 'right'
			}
		}, _nthChildOdd),
		'&:nth-child(even)': (_nthChildEven = {}, _nthChildEven['& > *'] = {
			'&:first-child': {
				float: 'right'
			},
			'&:last-child': {
				float: 'left'
			}
		}, _nthChildEven)
	}, _css3['@media (max-width: ' + _globalStyles.tabletPortraitMaxWidthBreakpoint + 'px)'] = (_ref = {}, _ref['& > *'] = {
		float: 'none !important'
	}, _ref), _css3['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		margin: '30px auto'
	}, _css3));
	
	var ContentStyle = /*#__PURE__*/exports.ContentStyle = (0, _emotion.css)({
		maxWidth: '668px'
	});

/***/ }),

/***/ 1081:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _commonPageHeader = __webpack_require__(371);
	
	var _arrowLink = __webpack_require__(52);
	
	var _whatWeDo = __webpack_require__(478);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WhatWeDoPage = function (_React$PureComponent) {
		_inherits(WhatWeDoPage, _React$PureComponent);
	
		function WhatWeDoPage() {
			_classCallCheck(this, WhatWeDoPage);
	
			return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
		}
	
		WhatWeDoPage.prototype.render = function render() {
			var blocks = this.props.data.page.edges[0].node.blocks;
	
	
			return _react2.default.createElement(
				'div',
				{ className: _whatWeDo.wrapperStyle },
				_react2.default.createElement(
					_reactHelmet.Helmet,
					{ title: 'About Us : What we do' },
					_react2.default.createElement('meta', { property: 'og:type', content: 'website' }),
					_react2.default.createElement('meta', { property: 'og:title', content: 'About Us : What we do' }),
					_react2.default.createElement('meta', { name: 'description', content: 'InsideOut is Australia\u2019s national institute for research and clinical excellence in eating disorders with global research partnerships. We aim to transform the treatment landscape for eating disorders in Australia, and ultimately find a cure.' }),
					_react2.default.createElement('meta', { property: 'og:description', content: 'InsideOut is Australia\u2019s national institute for research and clinical excellence in eating disorders with global research partnerships. We aim to transform the treatment landscape for eating disorders in Australia, and ultimately find a cure.' })
				),
				_commonPageHeader.CommonPageHeader,
				blocks.map(function (block, index) {
					return _react2.default.createElement(
						'section',
						{ key: index, className: _whatWeDo.innerWrapperStyle },
						_react2.default.createElement(
							'div',
							{ className: _whatWeDo.imgStyle },
							_react2.default.createElement('img', { src: block.image, alt: '' })
						),
						_react2.default.createElement(
							'div',
							{ className: _whatWeDo.ContentStyle },
							_react2.default.createElement(
								'h1',
								{ className: _whatWeDo.titleStyle },
								block.heading
							),
							_react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: block.body } }),
							block.link_destination && block.link_text && _react2.default.createElement(
								'p',
								null,
								_react2.default.createElement(
									_arrowLink.ArrowLink,
									{ to: block.link_destination },
									block.link_text
								)
							)
						)
					);
				})
			);
		};
	
		return WhatWeDoPage;
	}(_react2.default.PureComponent);
	
	WhatWeDoPage.propTypes = {
		data: _propTypes2.default.shape({
			page: _propTypes2.default.shape({
				edges: _propTypes2.default.arrayOf(_propTypes2.default.shape({
					node: _propTypes2.default.shape({
						blocks: _propTypes2.default.arrayOf(_propTypes2.default.shape({
							heading: _propTypes2.default.string,
							image: _propTypes2.default.string,
							body: _propTypes2.default.string,
							link_text: _propTypes2.default.string,
							link_destination: _propTypes2.default.string
						}))
					})
				}))
			})
		})
	};
	exports.default = WhatWeDoPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-us-what-we-do-index-js-3690d6c90b85ee375f9a.js